<template>
	<div class="preview" v-if="showPre" @click.self="clearPre">
		<div class="preview_box" v-if="bsid == 1">
			<div class="imglist">
				<el-carousel 
					@change="imgChange"
					indicator-position="none"
					class="imgswiper" arrow="always">
					<el-carousel-item 
					class="swiper-slide"
					v-for="item in imgList" :key="item">
					<img :src="item" >
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="opinter" v-if="imgList.length>1">
				{{index}}/{{imgList.length}}
			</div>
		</div>
		<div class="preview_box" v-else>
			<iframe :src="imgList"></iframe>
		</div>	
	</div>
</template>

<script>
	let that;
	export default {
		data(){
			return{
				index:1,
				showPre:false
			}
		},
		props:{
			imgList:{
				type:Array,
				default:[]
			},
			bsid:{
				type:Number,
				default:1//资源类型  默认图片轮播
			}
		},
		created() {
			that = this;
		},
		methods:{
			// 渲染下标
			imgChange(current){
				that.index = current+1
			},
			// 点击遮层关闭预览
			clearPre(){
				that.index = 1;
				that.showPre = false;
				that.$emit("clearPre")
			}
		},
		watch:{
			imgList(value){
				if(value.length > 0){
					that.showPre = true;
				}
			}
		}
	}
</script>

<style lang="scss">
	.preview{
		z-index: 1000;
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba($color: #000000, $alpha: 0.6);
		.preview_box{
			width: 100%;
			height: 100%;
			overflow-y: scroll;
			iframe{
				width: 100%;
				height: 100%;
				border: none;
				background: none;
			}
		}
		.imglist{
			margin: 90px auto 0 auto;
			padding: 20px;
			box-sizing: border-box;
			width: 35%;
			height: 75%;
			background: #fff;
			.imgswiper{
				height: 100% !important;
				.el-carousel__container{
					height: 100% !important;
				}
				.swiper-slide{
					display: flex;
					align-items: center;
					width: 100%;
					height: 100% !important;
					img{
						width: 100%;
					}
				}
			}
		}
		.opinter{
			width: 40px;
			height: 40px;
			border-radius: 50%;
			background: #fff;
			margin: 20px auto;
			text-align: center;
			line-height: 40px;
			font-size: 12px;
			font-weight: bold;
			color: #1E2129;
		}
	}
</style>
